import type { Map } from 'immutable';
import type { AnyAction, Reducer } from 'redux';
import { combineReducers } from 'redux-immutable';
import salesDashboardReducer from './Dashboard/reducer';

const salesReducer: Reducer<Map<string, unknown>, AnyAction> = Reflect.apply(
  combineReducers,
  undefined,
  [{ dashboard: salesDashboardReducer }],
);

export default salesReducer;
